<div>
    <form *ngIf="iProductFamily === PRODUCT_FAMILY.DigitalMarketing"
        [formGroup]="formsMap.get(PRODUCT_FAMILY.DigitalMarketing)!"
        (ngSubmit)="onSubmit(PRODUCT_FAMILY.DigitalMarketing)">

        <div class="row mb-10">
            <div [ngClass]="{'col-md-4':!isNewCampaign,'col-md-6':isNewCampaign}">
                <div class="row" fxLayout="row" fxLayoutAlign="center center">
                        <label class="col-md-4">{{ 'CLIENT' | translate }}</label>
                    <div class="col-md-8">
                        <ng-select [clearable]="false"
                            [ngClass]="{'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.clientId.errors }"
                            bindLabel="fullName" bindValue="id" [items]="allMyClients" formControlName="clientId">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div *ngIf="!isNewCampaign" class="col-md-4">
                <div class="row" fxLayout="row" fxLayoutAlign="center center">
                        <label class="col-md-4">{{ 'CAMPAIGN' | translate }}</label>
                    <div class="col-md-8">
                        <ng-select
                            [ngClass]="{'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.campaignId.errors}"
                            formControlName="campaignId" bindLabel="name" bindValue="id" [items]="myCampaigns">
                        </ng-select>
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.campaignId.errors"
                            class="invalid-feedback">
                            <div *ngIf="fDigiForm.campaignId.errors?.required">{{ 'PLEASE_SELECT_A_CAMPAIGN' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div [ngClass]="{'col-md-4':!isNewCampaign,'col-md-6':isNewCampaign}">
                <div *ngIf="!isNewCampaign">
                    <button style=" width: 200px; float: right;" (click)="onAddCampaign(true)"
                        class="btn btn-page-orange">{{ 'ADD_NEW_CAMPAIGN' | translate }}</button>
                </div>
                <div *ngIf="isNewCampaign">
                    <button (click)="onAddCampaign(false)" style=" width: 200px; float: right;"
                        class="btn btn-page-orange">{{ 'SHOW_EXISTING_CAMPAIGNS' | translate }}</button>
                </div>
            </div>
        </div>
        <div *ngIf="iProduct.canCustomerChoose && iProduct.isGoogle && iProduct.isFacebook" fxLayout="row"
            class="row mb-10">
            <div class="col-md-6">
                <div fxLayout="row" fxLayoutAlign="center center" class="row">
                    <div class="col-md-4">
                        <label>{{ 'MARKETING_PLATFORMS' | translate }}</label>
                    </div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-sm-2">
                                <input type="checkbox" id="isGoogle" formControlName="isGoogle"
                                    class="form-check-input" />
                            </div>
                            <label class="col-sm-8" for="isGoogle">{{ 'GOOGLE' | translate }}</label>
                        </div>
                        <div class="row">
                            <div class="col-sm-2">
                                <input type="checkbox" id="isFacebook" formControlName="isFacebook"
                                    class="form-check-input" />
                            </div>
                            <label class="col-sm-8" for="isFacebook">{{ 'META_FACEBOOK_INSTAGRAM' | translate }}</label>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <div *ngIf="isNewCampaign">
            <div class="row mb-10">
                <div class="col-md-6">
                    <div fxLayout="row" fxLayoutAlign="center center" class="row">
                        <div class="col-md-4">
                            <label>{{ 'BRAND_NAME' | translate }}</label>
                        </div>
                        <div class="col-md-8">
                            <input (change)="onNameChange($event)"
                                [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.brandName.errors }"
                                type="text" formControlName="brandName" class="form-control" />
                            <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.brandName.errors"
                                class="invalid-feedback">
                                <div *ngIf="fDigiForm.brandName.errors.required">{{ 'REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div fxLayout="row" fxLayoutAlign="center center" class="row">
                        <div class="col-md-4">
                            <label>{{ 'STUDIO_LOCATION_NAME' | translate }}</label>
                        </div>
                        <div class="col-md-8">
                            <input (change)="onNameChange($event)"
                                [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.studioLocationName.errors }"
                                type="text" formControlName="studioLocationName" class="form-control" />
                            <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.studioLocationName.errors"
                                class="invalid-feedback">
                                <div *ngIf="fDigiForm.studioLocationName.errors.required">{{ 'REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-10">
                <div class="col-md-12">
                    <div fxLayout="row" fxLayoutAlign="center center" class="row">
                        <div class="col-md-2">
                            <label>{{ 'CAMPAIGN_NAME' | translate }}</label>
                        </div>
                        <div class="col-md-10">
                            <input readonly
                                [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.campaignName.errors }"
                                type="text" formControlName="campaignName" class="form-control" />
                            <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.campaignName.errors"
                                class="invalid-feedback">
                                <div *ngIf="fDigiForm.campaignName.errors.required">{{ 'REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-10">
                <div class="col-md-6">
                    <div fxLayout="row" fxLayoutAlign="center center" class="row">
                        <div class="col-md-4">
                            <label>{{ 'STUDIO_EMAIL_ADDRESS' | translate }}</label>
                        </div>
                        <div class="col-md-8">
                            <input
                                [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.studioEmail.errors }"
                                type="text" formControlName="studioEmail" class="form-control" />
                            <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.studioEmail.errors"
                                class="invalid-feedback">
                                <div *ngIf="fDigiForm.studioEmail.errors.required">{{ 'REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div fxLayoutAlign="center center" class="row" class="row">
                        <div class="col-md-4">
                            <label>{{ 'STUDIO_PHONE_NUMBER' | translate }}</label>
                        </div>
                        <div class="col-md-8">
                            <input
                                [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.studioPhone.errors }"
                                type="text" formControlName="studioPhone" class="form-control" />
                            <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.studioPhone.errors"
                                class="invalid-feedback">
                                <div *ngIf="fDigiForm.studioPhone.errors.required">{{ 'REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="row mb-10">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Studio Address</label>
                        </div>
                        <div class="col-md-12">
                            <input
                                [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.studioAddress.errors }"
                                type="text" formControlName="studioAddress" class="form-control" />
                            <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.studioAddress.errors"
                                class="invalid-feedback">
                                <div *ngIf="fDigiForm.studioAddress.errors.required">{{ 'REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="row mb-10">
                <div class="col-md-12">
                        <label>{{ 'PROVIDE_FACEBOOK_PAGE_URL' | translate }}</label>
                </div>
                <div class="col-md-12">
                    <input
                        [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.fbPageUrl.errors }"
                        type="text" formControlName="fbPageUrl" class="form-control" />
                    <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.fbPageUrl.errors"
                        class="invalid-feedback">
                                <div *ngIf="fDigiForm.fbPageUrl.errors.required">{{ 'REQUIRED' | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="row mb-10">
                <div class="col-md-6">
                    <div fxLayout="row" fxLayoutAlign="center center" class="row">
                        <div class="col-md-4">
                            <label>{{ 'CRM_NAME' | translate }}</label>
                        </div>
                        <div class="col-md-8">
                            <input
                                [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.crmName.errors }"
                                type="text" formControlName="crmName" class="form-control" />
                            <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.crmName.errors"
                                class="invalid-feedback">
                                <div *ngIf="fDigiForm.crmName.errors.required">{{ 'CRM_NAME_IS_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div fxLayout="row" fxLayoutAlign="center center" class="row">
                        <div class="col-md-4">
                            <label>{{ 'CRM_ID' | translate }}</label>
                        </div>
                        <div class="col-md-8">
                            <input
                                [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.crmId.errors }"
                                type="text" formControlName="crmId" class="form-control" />
                            <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.crmId.errors"
                                class="invalid-feedback">
                                <div *ngIf="fDigiForm.crmId.errors.required">{{ 'CRM_ID_IS_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row mb-10">
                <div class="col-md-12">
                    <label>{{ 'NOTES' | translate }}</label>
                </div>
                <div class="col-md-12">
                    <textarea type="text" rows="3" class="form-control" formControlName="notes"
                        [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.notes.errors }"
                        [placeholder]="'ENTER_NOTE' | translate"> </textarea>
                    <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.DigitalMarketing) && fDigiForm.notes.errors"
                        class="invalid-feedback">
                        <div *ngIf="fDigiForm.notes.errors.required">{{ 'NOTE_IS_REQUIRED' | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <form *ngIf="iProductFamily === PRODUCT_FAMILY.AddPlatform"
        [formGroup]="formsMap.get(PRODUCT_FAMILY.AddPlatform)!"
        (ngSubmit)="onSubmit(PRODUCT_FAMILY.AddPlatform)">

        <div class="row mb-10">
            <div class="col-md-6">
                <div class="row" fxLayout="row" fxLayoutAlign="center center">
                    <label class="col-md-4">{{ 'CLIENT' | translate }}</label>
                    <div class="col-md-8">
                        <ng-select [clearable]="false"
                            [ngClass]="{'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.AddPlatform) && fAddPlatformForm.clientId.errors}"
                            bindLabel="fullName" bindValue="id" [items]="allMyClients" formControlName="clientId">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="row" fxLayout="row" fxLayoutAlign="center center">
                    <label class="col-md-4">{{ 'CAMPAIGN' | translate }}</label>
                    <div class="col-md-8">
                        <ng-select
                            [ngClass]="{'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.AddPlatform) && fAddPlatformForm.campaignId.errors}"
                            formControlName="campaignId" bindLabel="name" bindValue="id" [items]="myCampaigns">
                        </ng-select>
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.AddPlatform) && fAddPlatformForm.campaignId.errors"
                            class="invalid-feedback">
                            <div *ngIf="fAddPlatformForm.campaignId.errors?.required">{{ 'PLEASE_SELECT_A_CAMPAIGN' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div *ngIf="showAPGoogle || showAPFacebook" fxLayout="row"
            class="row mb-10">
            <div class="col-md-6">
                <div fxLayout="row" fxLayoutAlign="center center" class="row">
                    <div class="col-md-4">
                        <label>Marketing Platforms</label>
                    </div>
                    <div class="col-md-8">
                        <div *ngIf="showAPGoogle" class="row">
                            <div class="col-sm-2">
                                <input type="checkbox" id="isGoogle" formControlName="isGoogle"
                                    class="form-check-input" />
                            </div>
                            <label class="col-sm-8" for="isGoogle">Google</label>
                        </div>
                        <div *ngIf="showAPFacebook" class="row">
                            <div class="col-sm-2">
                                <input type="checkbox" id="isFacebook" formControlName="isFacebook"
                                    class="form-check-input" />
                            </div>
                            <label class="col-sm-8" for="isFacebook">Meta (Facebook/Instagram)</label>
                        </div>

                    </div>
                </div>
            </div>

        </div> -->
    </form>


    <form *ngIf="iProductFamily === PRODUCT_FAMILY.CampaignConsulting"
        [formGroup]="formsMap.get(PRODUCT_FAMILY.CampaignConsulting)!"
        (ngSubmit)="onSubmit(PRODUCT_FAMILY.CampaignConsulting)">
        <div class="row mb-10">
            <div class="col-md-12">
                        <label>{{ 'NOTES' | translate }}</label>
            </div>
            <div class="col-md-12">
                <textarea type="text" rows="3" class="form-control" formControlName="notes"
                    [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.CampaignConsulting) && fCampaignConsultingForm.notes.errors }"
                    [placeholder]="'ENTER_NOTE' | translate"> </textarea>
                <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.CampaignConsulting) && fCampaignConsultingForm.notes.errors"
                    class="invalid-feedback">
                    <div *ngIf="fCampaignConsultingForm.notes.errors.required">{{ 'NOTE_IS_REQUIRED' | translate }}</div>
                </div>
            </div>
        </div>
    </form>

    <form *ngIf="iProductFamily === PRODUCT_FAMILY.SEOProgram" [formGroup]="formsMap.get(PRODUCT_FAMILY.SEOProgram)!"
        (ngSubmit)="onSubmit(PRODUCT_FAMILY.SEOProgram)">

        <div class="row mb-10">
            <div class="col-md-12">
                <div fxLayoutAlign="row" fxLayoutAlign="center center" class="row" class="row">
                    <div class="col-md-2">
                        <label>{{ 'BUSINESS_ADDRESS' | translate }}</label>
                    </div>
                    <div class="col-md-10">
                        <input
                            [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessAddress.errors }"
                            type="text" formControlName="businessAddress" class="form-control" />
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessAddress.errors"
                            class="invalid-feedback">
                            <div *ngIf="fSEOForm.businessAddress.errors.required">{{ 'BUSINESS_ADDRESS_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-10">
            <div class="col-md-6">
                <div fxLayoutAlign="row" fxLayoutAlign="center center" class="row" class="row">
                    <div class="col-md-4">
                        <label>{{ 'BUSINESS_EMAIL_ADDRESS' | translate }}</label>
                    </div>
                    <div class="col-md-8">
                        <input
                            [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessEmail.errors }"
                            type="email" formControlName="businessEmail" class="form-control" />
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessEmail.errors"
                            class="invalid-feedback">
                            <div *ngIf="fSEOForm.businessEmail.errors.required">{{ 'BUSINESS_EMAIL_IS_REQUIRED' | translate }}</div>
                            <div *ngIf="fSEOForm.businessEmail.errors.email">{{ 'EMAIL_MUST_BE_A_VALID_EMAIL_ADDRESS' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div fxLayoutAlign="row" fxLayoutAlign="center center" class="row" class="row">
                    <div class="col-md-4">
                        <label>{{ 'BUSINESS_PHONE' | translate }}</label>
                    </div>
                    <div class="col-md-8">
                        <input
                            [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessPhone.errors }"
                            type="text" formControlName="businessPhone" class="form-control" />
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessPhone.errors"
                            class="invalid-feedback">
                            <div *ngIf="fSEOForm.businessPhone.errors.required">{{ 'BUSINESS_PHONE_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-10">
            <div class="col-md-6">
                <div fxLayoutAlign="row" fxLayoutAlign="center center" class="row" class="row">
                    <div class="col-md-4">
                        <label>{{ 'BUSINESS_NAME' | translate }}</label>
                    </div>
                    <div class="col-md-8">
                        <input
                            [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessName.errors }"
                            type="text" formControlName="businessName" class="form-control" />
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessName.errors"
                            class="invalid-feedback">
                            <div *ngIf="fSEOForm.businessName.errors.required">{{ 'BUSINESS_NAME_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-10">
            <div class="col-md-6">
                <div fxLayoutAlign="row" fxLayoutAlign="center center" class="row" class="row">
                    <div class="col-md-4">
                        <label>{{ 'WEBSITE_URL' | translate }}</label>
                    </div>
                    <div class="col-md-8">
                        <input
                            [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessWebsiteUrl.errors }"
                            type="text" formControlName="businessWebsiteUrl" class="form-control" />
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.SEOProgram) && fSEOForm.businessWebsiteUrl.errors"
                            class="invalid-feedback">
                            <div *ngIf="fSEOForm.businessWebsiteUrl.errors.required">{{ 'WEBSITE_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form *ngIf="iProductFamily === PRODUCT_FAMILY.HostedWebsite"
        [formGroup]="formsMap.get(PRODUCT_FAMILY.HostedWebsite)!" (ngSubmit)="onSubmit(PRODUCT_FAMILY.HostedWebsite)">

        <div class="row" class="row mb-10">
            <div class="col-md-12">
                <label>{{ 'WEBSITE_INFO' | translate }}</label>
            </div>
            <div class="col-md-12">
                <textarea type="text" rows="3" class="form-control" formControlName="websiteInfo"
                    [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.HostedWebsite) && fHostedWebsiteForm.websiteInfo.errors }"
                    [placeholder]="'ENTER_WEBSITE_INFO' | translate"> </textarea>
                <span style="font-size:10px">{{ 'PLEASE_PROVIDE_YOUR_URL_IF_YOU_HAVE_ONE' | translate }}</span>
                <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.HostedWebsite) && fHostedWebsiteForm.websiteInfo.errors"
                    class="invalid-feedback">
                    <div *ngIf="fHostedWebsiteForm.websiteInfo.errors.required">{{ 'NOTE_IS_REQUIRED' | translate }}</div>
                </div>
            </div>
        </div>

        <div class="row mb-10">
            <div class="col-md-12">
                        <label>{{ 'NOTES' | translate }}</label>
            </div>
            <div class="col-md-12">
                <textarea type="text" rows="3" class="form-control" formControlName="notes"
                    [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.HostedWebsite) && fHostedWebsiteForm.notes.errors }"
                    [placeholder]="'ENTER_NOTE' | translate"> </textarea>
                <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.HostedWebsite) && fHostedWebsiteForm.notes.errors"
                    class="invalid-feedback">
                    <div *ngIf="fHostedWebsiteForm.notes.errors.required">{{ 'NOTE_IS_REQUIRED' | translate }}</div>
                </div>
            </div>
        </div>
    </form>

    <form *ngIf="iProductFamily === PRODUCT_FAMILY.SocialMedia" [formGroup]="formsMap.get(PRODUCT_FAMILY.SocialMedia)!"
        (ngSubmit)="onSubmit(PRODUCT_FAMILY.SocialMedia)">


        <div class="row mb-10">
            <div class="col-md-12">
                <div fxLayoutAlign="row" fxLayoutAlign="center center" class="row">
                    <div class="col-md-4">
                        <label>{{ 'WEBSITE_URL' | translate }}</label>
                    </div>
                    <div class="col-md-8">
                        <input
                            [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.SocialMedia) && fSocialMediaForm.websiteUrl.errors }"
                            type="text" formControlName="websiteUrl" class="form-control" />
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.SocialMedia) && fSocialMediaForm.websiteUrl.errors"
                            class="invalid-feedback">
                            <div *ngIf="fSocialMediaForm.websiteUrl.errors.required">{{ 'REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-10">
            <div class="col-md-12">
                <div fxLayoutAlign="row" fxLayoutAlign="center center" class="row">
                    <div class="col-md-4">
                        <label>{{ 'INSTAGRAM_URL' | translate }}</label>
                    </div>
                    <div class="col-md-8">
                        <input
                            [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.SocialMedia) && fSocialMediaForm.instagramUrl.errors }"
                            type="text" formControlName="instagramUrl" class="form-control" />
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.SocialMedia) && fSocialMediaForm.instagramUrl.errors"
                            class="invalid-feedback">
                            <div *ngIf="fSocialMediaForm.instagramUrl.errors.required">{{ 'REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-10">
            <div class="col-md-12">
                <div fxLayoutAlign="row" fxLayoutAlign="center center" class="row">
                    <div class="col-md-4">
                        <label>{{ 'FACEBOOK_URL' | translate }}</label>
                    </div>
                    <div class="col-md-8">
                        <input
                            [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.SocialMedia) && fSocialMediaForm.facebookUrl.errors }"
                            type="text" formControlName="facebookUrl" class="form-control" />
                        <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.SocialMedia) && fSocialMediaForm.facebookUrl.errors"
                            class="invalid-feedback">
                            <div *ngIf="fSocialMediaForm.facebookUrl.errors.required">{{ 'REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row mb-10">
            <div class="col-md-12">
                <label>{{ 'ADDITIONAL_INFO_LINKS' | translate }}</label>
            </div>
            <div class="col-md-12">
                <textarea type="text" rows="3" class="form-control" formControlName="notes"
                    [ngClass]="{ 'is-invalid': formsSubmittedMap.get(PRODUCT_FAMILY.SocialMedia) && fSocialMediaForm.notes.errors }"
                    [placeholder]="'ENTER_NOTE' | translate"> </textarea>
                <div *ngIf="formsSubmittedMap.get(PRODUCT_FAMILY.SocialMedia) && fSocialMediaForm.notes.errors"
                    class="invalid-feedback">
                    <div *ngIf="fSocialMediaForm.notes.errors.required">{{ 'NOTE_IS_REQUIRED' | translate }}</div>
                </div>
            </div>
        </div>
    </form>
</div>
